import { useState } from 'react';
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function AlterarSenha() {
    const [senhaAtual, setSenhaAtual] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [erro, setErro] = useState('');
    const [loading, setLoading] = useState(false);
    const [mostrarAtual, setMostrarAtual] = useState(false);
    const [mostrarNova, setMostrarNova] = useState(false);
    const [mostrarConfirmacao, setMostrarConfirmacao] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();

        const errosSenha = validarNovaSenha(novaSenha);

        if (errosSenha.length > 0) {
            setErro(
                'A nova senha precisa: ' + errosSenha.join(', ') + '.'
            );
            return;
        }

        setLoading(true);

        try {
            const token = sessionStorage.getItem('access_token');

            const response = await fetch('https://api.atendimentocoliseumleiloes.com/api/admin/alterar-senha', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    senha_atual: senhaAtual,
                    nova_senha: novaSenha,
                    confirmar_senha: confirmarSenha,
                }),
            });

            const data = await response.json();

            if (!response.ok || !data.success) {
                setErro(data.message || 'Erro ao alterar senha.');
                return;
            }

            setMensagem('Senha alterada com sucesso. Faça login novamente.');

            sessionStorage.removeItem('access_token');

            setTimeout(() => {
                window.location.href = '/login';
            }, 1500);

        } catch (error) {
            setErro('Erro de conexão com o servidor.');
        } finally {
            setLoading(false);
        }
    }

    function validarNovaSenha(senha) {
        const erros = [];

        if (senha.length < 8) {
            erros.push('ter pelo menos 8 caracteres');
        }

        if (!/[A-Z]/.test(senha)) {
            erros.push('ter pelo menos 1 letra maiúscula');
        }

        if (!/[a-z]/.test(senha)) {
            erros.push('ter pelo menos 1 letra minúscula');
        }

        if (!/[0-9]/.test(senha)) {
            erros.push('ter pelo menos 1 número');
        }

        if (!/[^A-Za-z0-9]/.test(senha)) {
            erros.push('ter pelo menos 1 caractere especial');
        }

        return erros;
    }

    return (
        <div style={{ padding: '24px' }}>
            <h1>Alterar senha</h1>

            {erro && <div style={{ color: '#922B21', marginBottom: '12px' }}>{erro}</div>}
            {mensagem && <div style={{ color: '#1E8449', marginBottom: '12px' }}>{mensagem}</div>}

            <form onSubmit={handleSubmit} style={{ maxWidth: '420px' }}>
                <label>Senha atual</label>
                <div style={{ position: 'relative' }}>

                <input
                    type={mostrarAtual ? 'text' : 'password'}
                    value={senhaAtual}
                    onChange={(e) => setSenhaAtual(e.target.value)}
                    style={{
                        width: '100%',
                        padding: '10px 45px 10px 10px'
                    }}
                />

                <button
                    type="button"
                    onClick={() => setMostrarAtual(!mostrarAtual)}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px'
                    }}
                >
                    {mostrarAtual ? <FaEyeSlash /> : <FaEye />}
                </button>

            </div>

                <label>Nova senha</label>
                <div style={{ position: 'relative' }}>

                <input
                    type={mostrarNova ? 'text' : 'password'}
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                    style={{
                        width: '100%',
                        padding: '10px 45px 10px 10px'
                    }}
                />

                <button
                    type="button"
                    onClick={() => setMostrarNova(!mostrarNova)}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px'
                    }}
                >
                    {mostrarNova ? <FaEyeSlash /> : <FaEye />}
                </button>

            </div>

                <label>Confirmar nova senha</label>
                <div style={{ position: 'relative' }}>

                <input
                    type={mostrarConfirmacao ? 'text' : 'password'}
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                    style={{
                        width: '100%',
                        padding: '10px 45px 10px 10px'
                    }}
                />

                <button
                    type="button"
                    onClick={() => setMostrarConfirmacao(!mostrarConfirmacao)}
                    style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '18px'
                    }}
                >
                    {mostrarConfirmacao ? <FaEyeSlash /> : <FaEye />}
                </button>

            </div>

                <button type="submit" disabled={loading} style={buttonStyle}>
                    {loading ? 'Alterando...' : 'Alterar senha'}
                </button>
            </form>
        </div>
    );
}

const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '6px 0 14px',
    border: '1px solid #ccc',
    borderRadius: '6px',
};

const buttonStyle = {
    width: '100%',
    padding: '12px',
    background: '#2E86C1',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
};